var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderWifiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wifi-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99953 10.7627C6.75112 10.7627 7.36039 10.1535 7.36039 9.40188C7.36039 8.65029 6.75112 8.04102 5.99953 8.04102C5.24795 8.04102 4.63867 8.65029 4.63867 9.40188C4.63867 10.1535 5.24795 10.7627 5.99953 10.7627Z",
    fill: "#C80C0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.99999 5.77295C4.83053 5.77295 3.72597 6.34181 3.04535 7.29464C2.85116 7.56646 2.91413 7.94421 3.18591 8.13837C3.29247 8.21449 3.41529 8.25112 3.53697 8.25112C3.72568 8.25112 3.9116 8.16303 4.0296 7.9978C4.48371 7.36211 5.22028 6.98262 5.99996 6.98262C6.7797 6.98262 7.51624 7.36211 7.97028 7.99777C8.1644 8.26952 8.54215 8.33259 8.814 8.1384C9.08582 7.94425 9.14879 7.56649 8.95463 7.29468C8.27407 6.34177 7.16952 5.77295 5.99999 5.77295Z",
    fill: "#C80C0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.00015 3.50488C4.32956 3.50488 2.73053 4.21818 1.61295 5.46185C1.38971 5.71032 1.41011 6.09273 1.65861 6.31601C1.77415 6.41984 1.91865 6.47097 2.06266 6.47097C2.22831 6.47094 2.39331 6.40331 2.51273 6.27039C3.40122 5.28164 4.67235 4.71455 6.00018 4.71455C7.32802 4.71455 8.59918 5.28164 9.4877 6.27035C9.71098 6.51882 10.0934 6.53922 10.3418 6.31597C10.5903 6.0927 10.6107 5.71029 10.3874 5.46185C9.2698 4.21814 7.67071 3.50488 6.00015 3.50488Z",
    fill: "#C80C0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8268 3.68269C10.2785 2.10543 8.20916 1.23682 5.99998 1.23682C3.7909 1.23682 1.72157 2.10543 0.173212 3.68275C-0.0607911 3.92115 -0.0572491 4.30405 0.181116 4.53805C0.298856 4.65363 0.451852 4.71128 0.604782 4.71125C0.761419 4.71125 0.918022 4.65074 1.03642 4.53015C2.3555 3.18644 4.11825 2.44645 5.99998 2.44645C7.88181 2.44645 9.64456 3.18644 10.9635 4.53008C11.1975 4.76848 11.5805 4.77199 11.8188 4.53802C12.0572 4.30402 12.0608 3.92108 11.8268 3.68269Z",
    fill: "#C80C0F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderWifiRed);
export default __webpack_public_path__ + "static/media/header-wifi-red.e65cba3fed47d78e8b1225c59962c570.svg";
export { ForwardRef as ReactComponent };